import { render, staticRenderFns } from "./WordCloudColumnSelector.vue?vue&type=template&id=c1bc759a&scoped=true&"
import script from "./WordCloudColumnSelector.vue?vue&type=script&lang=js&"
export * from "./WordCloudColumnSelector.vue?vue&type=script&lang=js&"
import style0 from "./WordCloudColumnSelector.vue?vue&type=style&index=0&id=c1bc759a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bc759a",
  null
  
)

export default component.exports